import React, { useState, useEffect, useReducer, useRef } from "react";
import DataGrid, {
  Column,
  Lookup,
  HeaderFilter,
  Scrolling,
  SearchPanel,
} from "devextreme-react/data-grid";
import {
  CONFIG,
  sizeValues,
  fontValues,
  headerValues,
} from "../common/rps/config";
import ScrollView from "devextreme-react/scroll-view";
import { alert } from "devextreme/ui/dialog";
import * as utils from "../../common/utils";
import notify from "devextreme/ui/notify";
import FileUploader from "devextreme-react/file-uploader";
import { getTypeOfFile, onDownloadFile } from "../../common/utils";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import NEXUS_CONST from "../../common/constants";
import WhiteBoard from "../common/WhiteBoard/WhiteBoard";
import HtmlEditor, {
  Toolbar,
  MediaResizing,
  Item,
} from "devextreme-react/html-editor";
import { Button } from "devextreme-react/button";
import * as action from "../../actions/rps";
import rpsReducer from "../../reducers/rps";
import { CheckBox } from "devextreme-react/check-box";
import { confirm } from "devextreme/ui/dialog";
import moment from "moment";
import Validator, {
  RequiredRule,
  PatternRule,
} from "devextreme-react/validator";
import ACTION_TYPES from "../../actions/actionTypes";
import { postLogForFilter } from "./utils";
import { postUserLog } from "../../actions/common";
import { isEmpty } from "lodash";
import {
  set,
  get,
  setGridUserPrefs,
  setGridWidthPrefs,
  applyUserPref,
  saveUserPref,
} from "../../common/utils";
import config from "../../common/config";
import {
  ALLOWED_FILE_EXTENSIONS,
  ALLOWED_MIME_TYPES,
} from "../../constants/allowedUploadTypes";
import { checkUploadFilesValid } from "../../utils/fileValidator";
const initialStates = {
  approvers: [],
  peopleList: [],
  reasonCodes: [],
  rpsRail: [],
  userPrefSps: null,
};

const RapidExperiment = ({
  rpsID,
  activeAlert,
  siteId,
  data,
  activeItem,
  tierId,
  handleSPSSave,
  setisOpen,
  navigationOn,
}) => {
  const [theRpsId, setTheRpsId] = useState(rpsID == null ? 1 : rpsID);
  const [state, dispatch] = useReducer(rpsReducer, initialStates);
  let {
    approvers,
    ophFile,
    peopleList,
    reasonCodes,
    rpsRail,
    rpsAllData,
    userPrefSps,
  } = state;
  const widgetId = "spsBox6";
  const GRID_COLS = JSON.stringify([
    "experimentId",
    "description",
    "expectedResults",
    "dueDate",
    "actualResults",
    "notes",
    "followUpActions",
    "owner",
  ]);
  const loggedinUser = get("hid");
  const PREF_KEY = "userPref_" + widgetId;
  //   const [selectedFilesRC, setSelectedFilesRC] = useState([]);
  const [rootCauseAnalysis, setRootCauseAnalysis] = useState("");
  const [enableByWhen, setEnableByWhen] = useState(true);
  const [selectedFiles, setSelectedFiles] = useState([]);
  let wbIs, wbRc;
  const wBRc = (k) => {
    wbRc = k;
  };
  const [WBOpen, setWBOpen] = useState(false);
  const [WBRc, setWBRc] = useState(false);
  const refInitialValueState = useRef(null);
  const refRootCauseAnalysis = useRef(null);
  let { rapidExperimentData } = state;
  const { peopleData, experimentAttachmentData } = state;
  const [distinctUsers, setDistinctUsers] = useState([]);
  //const [whiteBoardData, setWhiteBoardData] =
  const [image, setImage] = useState(null);
  const [isEnabled, setIsEnabled] = useState(true);
  const [datagridEnabled, setdatagridEnabled] = useState(true);
  const [enable, setenable] = useState(false);
  const [IsExperiment, setIsExperiment] = useState([]);
  const [enableSave, setEanbleSave] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [scrollConfig] = useState({
    showScrollbar: "always",
    scrollByContent: true,
    scrollByThumb: true,
  });
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const dataGridRef = useRef(null);

  useEffect(() => {
    let siteInfo = `&siteId=` + siteId;
    utils.set("wbData_re", { objects: [] });
    action.fetchRapidExperimentGridData(dispatch, theRpsId);
    //action.fetchRCAGridData(dispatch, theRpsId)
    action.fetchPeopleList(dispatch, siteId);
    action.experimentGetAttachmentsData(dispatch, theRpsId, "Experiment");
  }, []);

  useEffect(() => {
    action.fetchUserPref(
      dispatch,
      `=${tierId}&SiteUID=${siteId}&widgetID=${widgetId}`
    );
    return () => {
      action.updateUserPref(
        dispatch,
        saveUserPref({
          widgetId,
          siteId,
          tierId,
          moduleName: "DownTimeReason",
          loggedinUser,
          prefSess: PREF_KEY,
          GRID_COLS,
        })
      );
    };
  }, []);

  useEffect(() => {
    if (userPrefSps) set(PREF_KEY, userPrefSps);
    if (
      dataGridRef &&
      dataGridRef.current &&
      dataGridRef.current.instance !== null &&
      userPrefSps &&
      gridData
    ) {
      applyUserPref(dataGridRef, userPrefSps);
    }
  }, [userPrefSps, gridData]);

  useEffect(() => {
    setGridData(rapidExperimentData);
  }, [rapidExperimentData]);

  useEffect(() => {
    AsyncCallHandler(
      NEXUS_CONST.FETCH_PS_DATA + theRpsId,
      NEXUS_CONST.GET
    ).then((res) => {
      if (res) {
        if (res && res.data) {
          let info = res.data;
          utils.set(
            "wbData_re",
            info.experimentWhiteBoard
              ? JSON.parse(info.experimentWhiteBoard)
              : { objects: [] }
          );
        }

        //setWhiteBoardData(res.data.experimentWhiteBoard);
        setenable(res?.data?.isExperiments);
        setEanbleSave(res?.data?.status === "Complete");
        // if(res.data.isExperiments == true)
        // {
        //     setenable(res.data.isExperiments);
        // }
        // else
        // {
        //     setenable(false);
        // }
        //setIsExperiment(res.data.isExperiments);
      }
    });
  }, []);

  useEffect(() => {
    // if(peopleData !== undefined)
    // {
    //  if (peopleData.length > 0) {
    populateDistinctUsersList();

    //  }
    //}
  }, [peopleData]);

  useEffect(() => {
    //utils.set('wbData_rc', whiteBoardData == '' ? rpsAllData?.experimentWhiteBoard : whiteBoardData)
    // setHtmlContent(defVal)
    utils.set(
      "wbData_rc",
      rpsAllData?.experimentWhiteBoard != ""
        ? rpsAllData?.experimentWhiteBoard
        : ""
    );
  }, [rpsAllData]);

  const populateDistinctUsersList = () => {
    let _distinctUsers = [
      ...new Map(peopleData?.map((ele) => [ele["employeeID"], ele])).values(),
    ];
    setDistinctUsers([..._distinctUsers]);
  };

  const onRowInserted = (data) => {
    let {
      rpsid,
      experimentId,
      description,
      expectedResults,
      dueDate,
      actualResults,
      followUpActions,
      notes,
      owner = [],
    } = data.data;
    rpsid = 1;
    let input = {
      rpsid: theRpsId,
      experimentId: 0,
      expectedResults: expectedResults,
      dueDate: moment(dueDate).format(),
      actualResults: actualResults,
      followUpActions: followUpActions,
      description: description,
      notes: notes,
      Owner: owner,
    };

    // action.saveExperiment(dispatch, input, theRpsId);

    // action.saveRPSRAIL(dispatch, input, selectedId);
  };

  const onRowUpdated = (data) => {
    let {
      rpsid,
      experimentId,
      description,
      expectedResults,
      dueDate,
      actualResults,
      followUpActions,
      notes,
      owner = [],
    } = data.data;

    let input = {
      rpsid: theRpsId,
      experimentId: experimentId,
      expectedResults: expectedResults,
      dueDate: moment(dueDate).format(),
      actualResults: actualResults,
      followUpActions: followUpActions,
      description: description,
      notes: notes,
      Owner: owner,
    };

    //action.saveExperiment(dispatch, input, theRpsId);
    //}
  };

  const deleteFile = (id) => {
    let confirm_it = confirm(
      "Are you sure you want to delete?",
      "Confirm changes"
    );

    confirm_it.then((res) => {
      if (res) {
        action.deleteFileAttachment(dispatch, id, theRpsId);
      }
    });
  };

  const submitRPS = () => {
    dataGridRef.current?.instance?.saveEditData();
    setEanbleSave(true);
    let totalFileSize = selectedFiles?.reduce((acc, cur) => {
      return (acc = acc + cur.size);
    }, 0);
    // Check files are valid or not
    const validateUploadFiles = checkUploadFilesValid(
      selectedFiles,
      ALLOWED_MIME_TYPES
    );

    if (validateUploadFiles.length) {
      const alertMsg = validateUploadFiles.map(
        (file) => `${file.name} - ${file.reason}`
      );
      alert(alertMsg.join("<br/>"), "Alert");
      setEanbleSave(false);
      return false;
    }

    if (
      (rapidExperimentData &&
        rapidExperimentData?.length == 0 &&
        enable == false) ||
      (selectedFiles?.length > 0 && totalFileSize > 4000000)
    ) {
      setEanbleSave(false);
      alert("Please enter value marked mandatory", "Alert");
      return false;
    } else {
      // let wbdata = utils.get('wbData_rc')

      let rootCauseWB = utils.get("wbData_re")
        ? JSON.stringify(utils.get("wbData_re"))
        : { objects: [] };
      let data = rpsAllData;
      data = {
        rpsid: theRpsId,
        experimentWhiteBoard: rootCauseWB,
        isExperiment: enable,
        experimentModel: rapidExperimentData,
        section: navigationOn,
        lastSavedTab: "6",
        siteId: siteId,
        tierId: tierId,
      };

      AsyncCallHandler(
        NEXUS_CONST.POST_MANAGE_EXPERIMENT,
        NEXUS_CONST.POST,
        data
      ).then((res) => {
        if (res) {
          if (selectedFiles?.length === 0) {
            setEanbleSave(false);
          }
          action.fetchProblemSovingDatabyId(dispatch, theRpsId);
          action.fetchRapidExperimentGridData(dispatch, theRpsId);
          handleSPSSave();
          setisOpen("6");
        }
      });

      handleSPSSave();
      setisOpen("6");
      if (selectedFiles?.length > 0) {
        let formData = new FormData();
        if (
          selectedFiles &&
          selectedFiles.length &&
          Array.isArray(selectedFiles)
        ) {
          selectedFiles.forEach((file) => {
            formData.append("files", file);
          });
        }
        formData.append("rpsId", theRpsId ? theRpsId : 0);
        formData.append("attachmentType", "Experiment");
        formData.append("section", navigationOn);
        formData.append("tierID", tierId);

        AsyncCallHandler(
          NEXUS_CONST.RCA_ATTACHMENT,
          NEXUS_CONST.PUT,
          formData
        ).then((res) => {
          setEanbleSave(false);
          dispatch({ type: ACTION_TYPES.RCA_ATTACHMENT, payload: res.data });
          action.experimentGetAttachmentsData(dispatch, theRpsId, "Experiment");
          setSelectedFiles([]);
        });
      }
    }
  };

  const onOphFile = () => {
    action.downloadOphFile(
      ophFile.file,
      "digitaltier/DownloadExcelFile?filename=" + ophFile.file
    );
  };

  const setPopup = (activeAlert) => {
    setTitle(activeAlert ? activeAlert.messageTitle : "");
    setDesc(activeAlert ? activeAlert.messageDescription : "");
  };

  const onRowRemoved = (data) => {
    let { rpsid, experimentId } = data.data;
    let input = {
      rpsid: theRpsId,
      experimentId: experimentId,
      IsArchive: "1",
    };

    // let confirm_it = confirm("Are you sure you want to delete?", "confirm");

    // confirm_it.then((res) => {
    //   if (res) {
    //     action.deleteExperiment(dispatch, experimentId, theRpsId);
    //   } else {
    //     action.fetchRapidExperimentGridData(dispatch, theRpsId);
    //   }
    // });
  };

  const handlers = {
    onRowInserted: onRowInserted,
    onRowUpdated: onRowUpdated,
    onRowRemoved: onRowRemoved,
  };

  const saveRA = () => {
    handleSPSSave();
  };

  const onFileSelect = (e) => {
    setSelectedFiles(e.value);
    if (e.value[0] !== undefined) {
      setImage(URL.createObjectURL(e.value[0]));
    }
  };
  //   const onFileSelectRC = (e) => {
  //     setSelectedFilesRC(e.value);
  //     if (e.value[0] !== undefined) {
  //       setImage(URL.createObjectURL(e.value[0]));
  //     }
  //   };

  const handleWhiteBoard = () => {
    setWBRc(!WBRc);
  };

  const handleInputChange = (e) => {
    // let value = e.value;
    setenable(e.value);
    //     if(value == false)
    //    {
    //   //  setIsEnabled(true)
    //     setdatagridEnabled(false)
    //    }
    //    else{
    //     //setIsEnabled(false)
    //     setdatagridEnabled(true)
    //    }
  };

  function handleGridOptionChanged(e) {
    postLogForFilter(
      dataGridRef,
      e,
      siteId,
      tierId,
      "Rapid Experiments",
      6,
      rpsID,
      navigationOn
    );
  }

  return (
    <>
      <div className="title-section">
        {" "}
        <h2 className="sps_title">
          <span className="sps-print">Box 6 - &nbsp;</span>Rapid Experiment
        </h2>{" "}
        <div className="sps-save-btn save-btn">
          <Button
            style={{ float: "right", width: "140px", "margin-top": "3%" }}
            disabled={enableSave}
            width={200}
            onClick={submitRPS}
            text="Save"
            type="normal"
          />
        </div>
      </div>

      <ScrollView width="100%" height="420px" className="sps-box-s">
        <div className="gridavailable">
          <div>
            <CheckBox
              name="chk"
              value={enable ?? false}
              onValueChanged={handleInputChange}
            />{" "}
            Not applicable
          </div>
          <div>
            <DataGrid
              dataSource={gridData}
              allowColumnReordering={true}
              showBorders={true}
              ref={dataGridRef}
              disabled={enable}
              {...CONFIG.RPS_EXPERIMENT}
              {...handlers}
              wordWrapEnabled={true}
              width={"100%"}
              onOptionChanged={handleGridOptionChanged}
              onExporting={() =>
                postUserLog({
                  event: `Box 6 - Rapid Experiment Export`,
                  data: {
                    action: `Rapid Experiment exported for PS-${rpsID}`,
                    module: "Digital Tier",
                    section: navigationOn,
                    siteUId: siteId,
                    widget: "Structured Problem Solving",
                    tierId,
                  },
                })
              }
              onToolbarPreparing={function (e) {
                var dataGrid = e.component;
                var toolbarItems = e.toolbarOptions.items;
                // Adds a new item
                toolbarItems.unshift(
                  {
                    location: "before",
                    template: "",
                  },
                  {
                    location: "after",
                    widget: "dxButton",
                    options: {
                      icon: "refresh",
                      hint: "Refresh",
                      onClick: function () {
                        dataGrid.refresh();
                        postUserLog({
                          event: `Box 6 - Rapid Experiment Refreshed`,
                          data: {
                            action: `Rapid Experiment refreshed for PS-${rpsID}`,
                            module: "Digital Tier",
                            section: navigationOn,
                            siteUId: siteId,
                            widget: "Structured Problem Solving",
                            tierId,
                          },
                        });
                      },
                    },
                  }
                );
              }}
              onContentReady={(e) => setGridUserPrefs(e, widgetId)}
              onColumnsChanging={(e) => setGridWidthPrefs(e, widgetId)}
            >
              <SearchPanel
                visible={true}
                onTextChange={(e) => {
                  if (!isEmpty(e)) {
                    postUserLog({
                      event: "Box 6 - Rapid Experiment Grid Search",
                      data: {
                        action: `${e} searched in rapid experiment grid for PS-${rpsID}`,
                        module: "Digital Tier",
                        section: navigationOn,
                        siteUId: siteId,
                        widget: "Structured Problem Solving",
                        tierId: tierId,
                      },
                    });
                  }
                }}
              />
              <Column
                dataField="rpsid"
                caption="PS ID"
                visible={false}
                allowEditing={false}
                minWidth={20}
                showInColumnChooser={false}
              ></Column>
              <Column
                dataField="experimentId"
                caption="Rapid Experiment ID"
                visible={false}
                allowEditing={false}
                minWidth={20}
                showInColumnChooser={false}
              ></Column>
              <Column
                dataField="description"
                caption="Experiment Description"
                visible={true}
                cssClass="WrappedColumn"
                width={200}
                minWidth={20}
              >
                <RequiredRule />
              </Column>
              <Column
                dataField="expectedResults"
                caption="Expected Results"
                visible={true}
                cssClass="WrappedColumn"
                width={200}
                minWidth={20}
              >
                <RequiredRule />
              </Column>

              <Column
                dataField="dueDate"
                caption="Due Date"
                dataType="date"
                width={110}
                minWidth={20}
              >
                <RequiredRule />
              </Column>
              <Column
                dataField="actualResults"
                caption="Actual Results"
                cssClass="WrappedColumn"
                width={200}
                minWidth={20}
              ></Column>
              <Column
                dataField="notes"
                caption="Notes"
                cssClass="WrappedColumn"
                width={200}
                minWidth={20}
              ></Column>
              <Column
                dataField="followUpActions"
                caption="Follow-up Actions"
                cssClass="WrappedColumn"
                width={200}
                minWidth={20}
              ></Column>
              <Column dataField="owner" caption="Owner" minWidth={20}>
                <Lookup
                  dataSource={distinctUsers}
                  valueExpr="employeeID"
                  displayExpr="employeeName"
                />
                <RequiredRule />
              </Column>
            </DataGrid>
          </div>

          {config.DEV_DISPLAY_OPTIONS && (
            <div className="wb-act-blk no-print">
              <Button
                className="rps-wb-btn"
                type="normal"
                disabled={enable}
                onClick={handleWhiteBoard}
              >
                <span className="icon whiteboard wh-50"></span>
              </Button>
            </div>
          )}
          {
            <>
              {config.DEV_DISPLAY_OPTIONS && WBRc && (
                <div>
                  <WhiteBoard
                    siteId={siteId}
                    isRps={true}
                    wbRef={wBRc}
                    rpsData={utils.get("wbData_re")}
                    widgetId={"re"}
                  />
                </div>
              )}
            </>
          }
          <div
            className="dx-field no-print"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div className="dx-field-label">Attachment</div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              {activeAlert?.imageName && (
                <div>
                  <a
                    style={{ cursor: "pointer" }}
                    className="clickable-hover"
                    onClick={() => {
                      getTypeOfFile(
                        {
                          imageName: activeAlert.imageName,
                          fileExtension: activeAlert?.imageName.split(".")[1],
                        },
                        "Sites"
                      );
                    }}
                  >
                    {" "}
                    {activeAlert?.imageName}
                  </a>
                  &nbsp; &nbsp;&nbsp;
                  {(activeAlert.imageName != "DELETED" || "") && (
                    <>
                      {" "}
                      <i
                        title="Delete"
                        className="fas fa-trash pointer"
                        onClick={(e) => deleteFile(e)}
                      ></i>
                      &nbsp; &nbsp;&nbsp;
                      <i
                        title="Download"
                        className="fa fa-download pointer"
                        onClick={() =>
                          onDownloadFile(activeAlert?.imageName, "Sites")
                        }
                      ></i>
                    </>
                  )}
                </div>
              )}
              {(!activeAlert?.imageName ||
                activeAlert?.imageName == "DELETED" ||
                "") && (
                // <FileUploader
                //   className="dx-field-value"
                //   selectButtonText="Choose file"
                //   labelText="Max. File Size 4 MB"
                //   accept="*"
                //   uploadMode="useForm"
                //   disabled={enable}
                //   multiple={true}
                //   onValueChanged={onFileSelect}
                //   value={selectedFiles}
                // />
                <FileUploader
                  className="dx-field-value gridavailable"
                  selectButtonText="Choose file"
                  labelText="Max. File Size 4 MB"
                  accept="*"
                  uploadMode="uploadUrl"
                  disabled={enable}
                  multiple={true}
                  onValueChanged={onFileSelect}
                  value={selectedFiles}
                  allowedFileExtensions={ALLOWED_FILE_EXTENSIONS}
                />
              )}
            </div>
          </div>
          <div className="no-print">
            {experimentAttachmentData &&
              experimentAttachmentData.map((item) => (
                <div>
                  <a
                    style={{ cursor: "pointer" }}
                    className="clickable-hover"
                    onClick={() => {
                      getTypeOfFile(
                        {
                          imageName: item?.attachmentName,
                          folderName: "RPS",
                          subfolderName: "Experiment",
                          fileExtension: "xls",
                        },
                        "RPS"
                      );
                    }}
                  >
                    {" "}
                    {item?.attachmentName}{" "}
                  </a>
                  <span className="rca_download">
                    <i
                      title="Download"
                      className="fa fa-download pointer"
                      onClick={() =>
                        onDownloadFile(
                          item?.attachmentName,
                          "RPS",
                          "Experiment"
                        )
                      }
                    ></i>
                  </span>
                  <span
                    className="rca_delete"
                    style={{ padding: "0px 15px 0px 10px" }}
                  >
                    <i
                      title="Delete"
                      className="fas fa-trash pointer"
                      onClick={() => deleteFile(item.id)}
                    ></i>
                  </span>
                </div>
              ))}
          </div>
        </div>
      </ScrollView>
    </>
  );
};
export default RapidExperiment;
